// extracted by mini-css-extract-plugin
export default {"listItem":"ReviewPayment_listItem__Cni5S","total":"ReviewPayment_total__LNOBI","title":"ReviewPayment_title__kFncM"};